// extracted by mini-css-extract-plugin
export default {"button":"_F3M8D8Q","content":"rOWuSPP8","letterSpacing":"AFBNY_GG"};